export const customWords = [
    'U.S.',
    'C.F.R.',
    'U.S.C.',
    'a.m.',
    'p.m.',
    'CDFI',
    'FAMIS',
    'VASAP',
    'IICRC',
    'licensure',
    'pre-release',
    'HIPAA',
    'and/or',
    // Browser is fine with these but this dictionary is not
    'permittee',
    'cancelled',
    'person(s)',
    'cremains',
    'evidentiary',
    'Prefiled',
    'Engrossment—Senator',
    'Engrossment—Delegate',
    'Substitute—Senator',
    'Substitute—Delegate',
]

// https://en.wikipedia.org/wiki/List_of_Latin_legal_terms
export const latinPhrases = [
    "a fortiori",
    "a mensa et thoro",
    "a posteriori",
    "a priori",
    "a quo",
    "ab extra",
    "ab initio",
    "absque hoc",
    "Actio non datur non damnificato",
    "Actus legis nemini facit injurium",
    "Actus non facit reum, nisi mens sit rea",
    "actus reus",
    "ad coelum",
    "ad colligenda bona",
    "ad hoc",
    "ad hominem",
    "ad idem",
    "ad infinitum",
    "ad litem",
    "ad quod damnum",
    "ad valorem",
    "adjournment sine die",
    "affidavit",
    "allocatur",
    "alter ego",
    "Alteri stipulari nemo potest",
    "amicus curiae",
    "animus contrahendi",
    "animus manendi",
    "animus nocendi",
    "animus possidendi",
    "animus revertendi",
    "animus testandi",
    "ante",
    "bona fide",
    "bona vacantia",
    "cadit quaestio",
    "casus belli",
    "caveat",
    "caveat emptor",
    "certiorari",
    "cessante ratione legis cessat ipsa lex",
    "ceteris paribus",
    "compos mentis",
    "condicio sine qua non",
    "consensus ad idem",
    "contra",
    "contra legem",
    "contradictio in adjecto",
    "contra proferentem",
    "coram non judice",
    "corpus delicti",
    "corpus juris",
    "corpus juris civilis",
    "corpus juris gentium",
    "corpus juris secundum",
    "crimen falsi",
    "cui bono",
    "curia advisari vult",
    "de bonis asportatis",
    "debellatio",
    "de bonis non administratis",
    "de die in diem",
    "de facto",
    "de futuro",
    "de integro",
    "de jure",
    "de lege ferenda",
    "de lege lata",
    "de minimis",
    "de minimis non curat lex",
    "de novo",
    "deorum injuriae diis curae",
    "dictum",
    "doli incapax",
    "dolus bonus",
    "dolus malus",
    "dolus specialis",
    "domitae naturae",
    "donatio mortis causa",
    "dramatis personae",
    "duces tecum",
    "ejusdem generis",
    "eo nomine",
    "erga omnes",
    "ergo",
    "erratum",
    "et al",
    "et cetera",
    "et seq",
    "et uxor",
    "et vir",
    "ex aequo et bono",
    "ex ante",
    "ex cathedra",
    "ex concessis",
    "ex delicto",
    "ex demissione",
    "Ex dolo malo non oritur actio",
    "ex facie",
    "ex fida bona",
    "ex gratia",
    "ex officio",
    "ex parte",
    "ex post",
    "ex post facto",
    "ex post facto law",
    "ex proprio motu",
    "ex rel",
    "ex tempore",
    "exempli gratia",
    "ex tunc",
    "Ex turpi causa non oritur actio",
    "ex nunc",
    "extant",
    "facio ut facias",
    "factum",
    "favor contractus",
    "felo de se",
    "ferae naturae",
    "fiat",
    "fieri facias",
    "fortis attachiamentum, validior praesumptionem",
    "forum non conveniens",
    "fumus boni iuris",
    "functus officio",
    "gravamen",
    "guardian ad litem",
    "habeas corpus",
    "hostis humani generis",
    "imprimatur",
    "in absentia",
    "in articulo mortis",
    "in camera",
    "in curia",
    "in esse",
    "in extenso",
    "in extremis",
    "in flagrante delicto",
    "in forma pauperis",
    "in futuro",
    "in haec verba",
    "in limine",
    "in loco parentis",
    "in mitius",
    "in omnibus",
    "in pari delicto",
    "in pari materia",
    "in personam",
    "in pleno",
    "in propria persona",
    "in re",
    "in rem",
    "in situ",
    "in terrorem",
    "in terrorem clause",
    "in toto",
    "indicia",
    "infra",
    "iniuria sine damno",
    "innuendo",
    "inter alia",
    "inter rusticos",
    "inter se",
    "inter vivos",
    "intra",
    "intra fauces terrae",
    "intra legem",
    "intra vires",
    "ipse dixit",
    "ipsissima verba",
    "ipso facto",
    "ipso jure",
    "ius",
    "ius civile vigilantibus scriptum est",
    "jurat",
    "juris privati",
    "jus",
    "jus accrescendi",
    "jus ad bellum",
    "jus civile",
    "jus cogens",
    "jus gentium",
    "jus in bello",
    "jus inter gentes",
    "jus legationis",
    "jus naturale",
    "jus primae noctis",
    "jus sanguinis",
    "jus soli",
    "jus tertii",
    "Jus tractatuum",
    "lacuna",
    "lex communis",
    "lex fori",
    "lex lata",
    "lex loci",
    "lex scripta",
    "liberum veto",
    "lingua franca",
    "lis alibi pendens",
    "lis pendens",
    "locus",
    "locus delicti",
    "locus in quo",
    "locus poenitentiae",
    "locus standi",
    "mala fide",
    "malum in se",
    "malum prohibitum",
    "mandamus",
    "mare clausum",
    "mare liberum",
    "mea culpa",
    "mens rea",
    "modus operandi",
    "mortis causa",
    "mos pro lege",
    "motion in limine",
    "mutatis mutandis",
    "ne exeat",
    "Nemo dat quod non habet",
    "Nemo iudex in causa sua",
    "Nemo potest dare quod suum non est",
    "Nemo potest esse tenens et dominus",
    "Nemo potest mutare consilium suum in alterius iniuriam",
    "Nemo potest nisi quod de jure potest",
    "Nemo potest praecise cogi ad factum",
    "Nemo potest venire contra factum proprium",
    "Nemo potest facere per alium quod per se non potest",
    "nihil dicit",
    "nisi",
    "nisi prius",
    "nolle prosequi",
    "nolo contendere",
    "non adimpleti contractus",
    "non compos mentis",
    "non constat",
    "non est factum",
    "non est inventus",
    "non liquet",
    "non obstante verdicto",
    "novus actus interveniens",
    "noscitur a sociis",
    "nota bene",
    "Nullum crimen sine lege",
    "Nulla poena sine culpa",
    "nudum pactum",
    "nulla bona",
    "nunc pro tunc",
    "obiter dictum",
    "onus probandi",
    "ore tenus",
    "pace",
    "par delictum",
    "parens patriae",
    "pari passu",
    "partus sequitur ventrem",
    "pendente lite",
    "per capita",
    "per contra",
    "per curiam",
    "per incuriam",
    "per minas",
    "per proxima amici",
    "per quod",
    "per se",
    "per stirpes",
    "periculum in mora",
    "persona non grata",
    "posse comitatus",
    "post hoc ergo propter hoc",
    "post mortem",
    "post mortem auctoris",
    "postliminium",
    "praetor peregrinus",
    "prima facie",
    "pro bono",
    "pro bono publico",
    "pro forma",
    "pro hac vice",
    "pro per",
    "pro rata",
    "pro se",
    "pro tanto",
    "pro tem",
    "pro tempore",
    "propria persona",
    "qua",
    "quae ipso usu consumuntur",
    "quaeritur",
    "quaere",
    "quantum",
    "quantum meruit",
    "quantum valebant",
    "quasi",
    "qui tam",
    "quid pro quo",
    "quo ante",
    "quo warranto",
    "quoad hoc",
    "ratio decidendi",
    "ratio scripta",
    "rationae soli",
    "rebus sic stantibus",
    "reddendo singula singulis",
    "res",
    "res communis",
    "res derelictae",
    "res ipsa loquitur",
    "res gestae",
    "res judicata",
    "res nova",
    "res nullius",
    "res publica",
    "respondeat superior",
    "scandalum magnatum",
    "scienter",
    "scire facias",
    "scire feci",
    "secundum formam statuti",
    "se defendendo",
    "seriatim",
    "sine die",
    "sine qua non",
    "situs",
    "stare decisis",
    "status quo status quo ante statu quo",
    "stratum",
    "sua sponte",
    "sub judice",
    "sub modo",
    "sub nomine",
    "sub silentio",
    "subpoena",
    "subpoena ad testificandum",
    "subpoena duces tecum",
    "suggestio falsi",
    "sui generis",
    "sui juris",
    "suo motu",
    "supersedeas",
    "suppressio veri",
    "supra",
    "terra nullius",
    "trial de novo",
    "trinoda necessitas",
    "uberrima fides",
    "ubi eadem ratio, ibi idem jus",
    "ubi jus ibi remedium",
    "ultra vires",
    "universitas personarum",
    "universitas rerum",
    "uno flatu",
    "uti possidetis",
    "uxor",
    "vel non",
    "veto",
    "vice versa",
    "vide",
    "videlicet",
    "viz",
    "vigilantibus non dormientibus iura subveniunt",
    "accessio",
    "accidentalia negotii",
    "actus iuridicus",
    "ad quantitatem",
    "aditio hereditatis",
    "aliquid novi",
    "casum sentit dominus",
    "casus fortuitus",
    "cautio de restituendo",
    "cessio",
    "collatio bonorum",
    "commixtio",
    "commodatum",
    "communio bonorum",
    "compensatio",
    "compensatio morae",
    "confusio",
    "conjunctissimus",
    "contra bonos mores",
    "culpa",
    "cum beneficio inventarii",
    "cum onere",
    "cura",
    "curator",
    "damnum emergens",
    "damnum et interesse",
    "data certa",
    "datio in solutum",
    "de cujus",
    "delatio hereditatis",
    "domicilium citandi et executandi",
    "dominium plurium in solidum",
    "dominium pro parte pro indiviso",
    "dominus litis",
    "error in iudicando",
    "error in procedendo",
    "essentialia negotii",
    "ex intervalo temporis",
    "ex propriis sensibus",
    "factum iuridicum",
    "falsus procurator",
    "fideicommissum",
    "fideiussio",
    "fructus industriales",
    "fructus naturales",
    "hereditas iacens",
    "heres",
    "hypotheca",
    "idem debitum",
    "in casu",
    "in solidum",
    "inaedificatio",
    "inaudita altera parte",
    "incapax",
    "infans",
    "invecta et illata",
    "iudex ad quem",
    "iudex a quo",
    "iura novit curia",
    "ius accrescendi",
    "ius commune",
    "ius persequendi",
    "ius praeferendi",
    "ius quaesitum tertio",
    "ius retentionis",
    "ius variandi",
    "laesio enormis",
    "lex commissoria",
    "liberandi causa",
    "locatio conductio",
    "lucrum cessans",
    "mandatum",
    "monstrum",
    "mora accipiendi",
    "mora solvendi",
    "mutuum",
    "naturalia negotii",
    "nec vi, nec clam, nec precario",
    "negotiorum gestio",
    "negotium iuridicum",
    "non bis in idem",
    "novum iudicium",
    "nudum praeceptum",
    "pactum de contrahendo",
    "pactum de non cedendo",
    "pactum de retrovendendo",
    "pactum reservati dominii",
    "pactum successorium",
    "pars dominii",
    "paterfamilias",
    "penitus extraneus",
    "per aversionem",
    "per relationem",
    "pignus",
    "pleno iure",
    "plus quam tolerabile",
    "praedium",
    "praeemptio",
    "praesumptio",
    "praesumptio innocentiae",
    "praesumptio veritatis et solemnitatis",
    "pretium pro doloribus",
    "prior tempore potior iure",
    "probatio",
    "procuratio",
    "procurator",
    "quaestus liberales",
    "restitutio in integrum",
    "revisio prioris instantiae",
    "salva rei substantia",
    "servitus",
    "si sine liberis decesserit",
    "solarium",
    "solutio indebiti",
    "specificatio",
    "spei emptio, emptio spei",
    "spes futurae actionis",
    "spes successionis",
    "spoliatio",
    "stante matrimonio",
    "stipulatio alteri",
    "superficies",
    "tantum et tale",
    "transactio",
    "tutela",
    "Unus testis, nullus testis",
    "uno contextu",
    "usucapio",
    "usufructus",
    "via executoria",
    "via iure",
    "vinculum iuris",
    "vis maior",
    "vitium in contrahendo",
    "voluntatis declaratio",
    "advocatus diaboli",
    "de iure quaesito non tollendo",
    "ebdomadarius",
    "eleemosynae",
    "embryo formatus",
    "embryo informatus",
    "episcoporum ecidicus",
    "episcopus puerorum",
    "excommunicato capiendo",
    "excommunicato recapiendo",
    "Extravagantes",
    "formata",
    "gardianus ecclesiae",
    "legit vel non",
    // Not possible with current implementation
    // "(in) arguendo",
    // "Nemo debet bis vexari (pro una et eadem causa)",
    // "indignus (heres)",
    // "pactum de non petendo (in anticipando)",
    // Okay, possible - but really?
    // "R",
]

export const splitPhrases = latinPhrases.map(phrase =>
    phrase.toLowerCase().split(' ').reverse())
